import type { SwitchboardRoutingEnum } from '../types'
import type { ScheduleEventHelper } from './scheduleEventHelper'

/**
 * Determine the effective current routing state from schedule events.
 * Priority:
 * 1) Active overrides (HOLIDAY wins over CLOSED)
 * 2) Active weekly-hours windows => OPEN
 * 3) Otherwise CLOSED
 */
export const getCurrentRoutingState = (
  helpers: ScheduleEventHelper[],
): SwitchboardRoutingEnum => {
  const activeOverrides = helpers.filter(
    (helper) => helper.isOverrideEvent() && helper.isCurrentlyActive(),
  )

  if (activeOverrides.length > 0) {
    if (
      activeOverrides.some(
        (helper) => helper.getSwitchboardRouting() === 'HOLIDAY',
      )
    ) {
      return 'HOLIDAY'
    }

    if (
      activeOverrides.some(
        (helper) => helper.getSwitchboardRouting() === 'CLOSED',
      )
    ) {
      return 'CLOSED'
    }

    return 'OPEN'
  }

  const isWithinWeeklyHours = helpers.some(
    (helper) => helper.isWeeklyHoursEvent() && helper.isCurrentlyActive(),
  )

  return isWithinWeeklyHours ? 'OPEN' : 'CLOSED'
}
